import React from 'react';

interface ISemiCircleProgress {
  width: number;
  height: number;
  strokeColor: string;
  strokeWidth: number;
  backgroundColor: string;
  diameter: number;
  percentage: number;
  outerStrokeWidth?: number;
}

const GAP_PERCENTAGE = 0.25;

const SemiCircleProgress = ({
  width = 220,
  height = 220,
  strokeColor = Styles.color.white,
  backgroundColor = 'rgba(34, 34, 34, 0.26)',
  strokeWidth = 8,
  diameter = 200,
  outerStrokeWidth,
  percentage,
}: ISemiCircleProgress): JSX.Element => {
  // radius minus stroke width
  const radius = diameter / 2 - strokeWidth / 2;
  const totalCircumference = Math.ceil(2 * Math.PI * radius);
  // This is the bottom gap
  const gap = Math.floor(totalCircumference * GAP_PERCENTAGE);
  // circumference minus the gap
  const circumference = totalCircumference - gap;
  // fraction remain plus the gap.
  const percentAsDecimal = percentage / 100;
  const remaining = Math.floor(circumference - circumference * percentAsDecimal) + gap;

  const centerX = width / 2;
  const centerY = height / 2;
  const viewBox = [0, 0, width, height].join(' ');
  return (
    <svg
      role="progressbar"
      width={width}
      height={height}
      viewBox={viewBox}
      style={{
        transform: `rotate(-45deg) rotateY(180deg) rotateX(180deg)`,
      }}
    >
      <circle
        cx={centerX}
        cy={centerY}
        r={radius}
        fill="none"
        stroke={backgroundColor}
        strokeWidth={outerStrokeWidth || strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={0}
        strokeLinecap="round"
      />
      <circle
        cx={centerX}
        cy={centerY}
        r={radius}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        style={{
          strokeDasharray: totalCircumference,
          strokeDashoffset: remaining,
          transition: 'stroke-dashoffset 2s ease 0s, stroke-dasharray 2s ease 0s, stroke 2s',
        }}
      />
    </svg>
  );
};

export default SemiCircleProgress;
